<div class="health-container">
  <h2 class="d-flex align-items-center">
    <span (click)="returnToList()" class="material-icons link mr-2">chevron_left</span><span>
      {{ this.currentId ? 'Editar post' : 'Nuevo post' }}
    </span>
  </h2>

  <form action="#" autocomplete="off" [formGroup]="healthForm" (submit)="saveHealthDetail($event)">
    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2rem">
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Titulo del post: </span>
        <mat-form-field fxFlex>
          <input matInput placeholder="Titulo" formControlName="title" />
          <mat-error *ngIf="healthForm.get('title').hasError('required')">
            Titulo requerido
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Imagen del post: </span>
        <img *ngIf="newImgPreview" class="img-80" src="{{ newImgPreview }}" alt="" />
        <a (click)="uploadNewHealthItemImg()" mat-stroked-button color="primary">
          <i class="material-icons">add</i>
          Cambiar imagen
        </a>
        <input (change)="handleNewImgUpload($event.target.files[0])" type="file" id="healthItemFileInput" hidden />
      </div>
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Tags: </span>
        <mat-chip-list *ngIf="tags.length" fxFlex>
          <mat-chip selected color="primary" *ngFor="let tag of tags">{{
            tag.name
          }}</mat-chip>
        </mat-chip-list>
        <a mat-stroked-button color="primary" (click)="addTag()">
          <i class="material-icons">add</i>
          Agregar tag
        </a>
      </div>
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Texto y contenido: </span>
        <mat-form-field fxFlex>
          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" formControlName="content"></textarea>
          <mat-error *ngIf="healthForm.get('content').hasError('required')">
            Contenido requerido
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Publicar: </span>
        <mat-slide-toggle color="primary" formControlName="status"></mat-slide-toggle>

      </div>
      <div fxLayout="row" fxLayoutGap="1rem" class="d-flex align-items-center w-100">
        <span fxFlex="20">Sponsor: </span>
        <div class="promoters__list" fxLayout="row" fxLayoutGap="2rem" fxLayoutAlign="start center">
          <div class="promoter__item" *ngFor="let promoter of promoters; let i=index" [matTooltip]="promoter.name">
            <img src="{{promoter.image}}" alt="" class="img-80">
            <a mat-icon-button (click)="removePromoter(i)" class="link">
              <i class="material-icons">cancel</i>
            </a>
          </div>
        </div>
        <a (click)="openNewPromoterDialog()" mat-stroked-button color="primary">
          <i class="material-icons">add</i>
          Agregar Sponsor
        </a>
      </div>
      <div class="actions w-100" fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="end center">
        <button type="submit" mat-raised-button [disabled]="!healthForm.valid || !tags.length" color="primary">
          Guardar</button>
      </div>
    </div>
  </form>
</div>